import s from '../Vouchers.module.scss';
import Button from 'components/shared/Button/Button';
import CloseIcon from '../../../../../../images/new-icons/cross-thin-black.svg';
import { ReactComponent as RiyalIcon } from 'images/new-icons/riyal.svg';
import { VoucherCard } from '../VoucherCard';
import { useParams } from 'react-router-dom';
import useGetSalonById from 'sdk/hooks/salon/useGetSalonById';
import { FC, useState } from 'react';
import { createInvoice } from 'sdk/hooks/payments/useCreateInvoice';
import useIsAuth from 'sdk/hooks/useIsAuth';
import supabase from 'sdk/api';
import useAddVaucherToBasket from 'sdk/hooks/shop/useAddVaucherToBasket';
// import useRemoveAllProduct from 'sdk/hooks/shop/useRemoveAllProduct';

type ResultStepProps = {
  email: string;
  deliveryDate: any;
  voucherData: any;
  onBack: () => void;
  activeTime: string;
  setActiveTime: (activeTime: string) => void;
  messageVaucher?: string;
};

const deliveryDateFormat = (data, setErrorMessage) => {
  let day: number, month: number, year: number;

  if (data.date instanceof Date) {
    day = data.date.getDate();
    month = data.date.getMonth() + 1;
    year = data.date.getFullYear();
  } else if (typeof data.date === 'string') {
    const parts = data.date.split('-'); // ['2025','09','08']
    if (parts.length !== 3) throw new Error('Invalid date format');
    year = Number(parts[0]);
    month = Number(parts[1]);
    day = Number(parts[2]);
  } else if (data.date?.day && data.date?.month && data.date?.year) {
    ({ day, month, year } = data.date);
  } else {
    throw new Error('Invalid date format');
  }

  if (!data.time) {
    throw new Error('Invalid time format');
  }

  const [timePart, modifier] = data.time.split(' ');
  const [hours, minutes] = timePart.split(':').map(Number);
  const adjustedHours =
    modifier === 'PM' && hours !== 12 ? hours + 12 : modifier === 'AM' && hours === 12 ? 0 : hours;

  const utcDate = new Date(Date.UTC(year, month - 1, day, adjustedHours, minutes, 0));
  setErrorMessage('');

  return utcDate.toISOString();
};

const ResultStep: FC<ResultStepProps> = ({
  email,
  deliveryDate,
  voucherData,
  onBack,
  activeTime,
  setActiveTime,
  messageVaucher,
}) => {
  const { id } = useParams();
  const { data } = useGetSalonById(id);
  const { data: isAuthData } = useIsAuth();
  const fromUserID = isAuthData?.user?.id;
  // const navigate = useNavigate();

  console.log('deliveryDate', deliveryDate);
  const { mutate: addToBasket } = useAddVaucherToBasket();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  // const { mutateAsync: removeItems } = useRemoveAllProduct();

  const formatDeliveryDateTime = () => {
    if (deliveryDate.mode === 'now') {
      return `Today, ${new Date().toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      })}, right after the purchase`;
    } else {
      let dateObj: Date;
      if (typeof deliveryDate.date === 'string') {
        dateObj = new Date(deliveryDate.date); // parse 'YYYY-MM-DD'
      } else {
        dateObj = new Date(
          deliveryDate.date.year,
          deliveryDate.date.month - 1,
          deliveryDate.date.day,
        );
      }

      const formattedDate = dateObj.toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
      });

      return `${formattedDate}, ${deliveryDate.time}`;
    }
  };

  const handlePay = async () => {
    setIsLoading(true);
    try {
      const { data: currentUser, error: currentUserError } = await supabase
        .from('user_profiles')
        .select('id')
        .eq('email', email)
        .single();

      if (currentUserError || !currentUser?.id) {
        console.log('Error while finding user by email: ', currentUserError);
        setErrorMessage('User with this email not found');
        return;
      }

      const { date, time } = deliveryDate;

      if (activeTime === 'choose' && (!date || !time)) {
        setErrorMessage('Date or time is missing');
        return;
      }

      // @ts-ingore
      const addToBasketResult = await new Promise((resolve, reject) => {
        addToBasket(
          {
            createdBy: isAuthData?.user?.id,
            productId: voucherData?.id,
            price: voucherData?.value,
          },
          {
            onSuccess: data => {
              console.log('Product added successfully');
              resolve(data);
            },
            onError: error => {
              console.error('Error adding to bag:', error);
              reject(error);
            },
            onSettled: () => {},
          },
        );
      });
      // @ts-ingore
      const { orderId } = addToBasketResult as any;

      const res = await createInvoice({
        order_id_vaucher: orderId,
        description: 'Voucher',
        totalPrice: voucherData?.value * 100,
        user_id: fromUserID,
        messageVaucher: messageVaucher,
        voucherId: voucherData?.id,
        to_user_id: currentUser.id,
        delivery_date: deliveryDate?.date
          ? deliveryDateFormat(deliveryDate, setErrorMessage)
          : null,
        salonId: id,
      });
      console.log('res: ', res);
      window.location.href = res;
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={s.vouchers_step}>
      <img src={CloseIcon} alt="email" onClick={onBack} className={s.vouchers_step_close} />
      <div className={s.vouchers_step_stage}>
        <div className={s.vouchers_step_stage_active}></div>
        <div className={s.vouchers_step_stage_active}></div>
        <div className={s.vouchers_step_stage_active}></div>
      </div>
      <div className={s.vouchers_step_voucher}>
        <VoucherCard
          style={{ marginTop: '25px' }}
          variant={voucherData?.color?.toLowerCase()}
          {...voucherData}
        />
      </div>

      <div className={s.vouchers_step_title3 + ' ' + s.vouchers_step_title3_margin}>
        Phone number
      </div>

      <p className={s.vouchers_step_description2 + ' ' + s.vouchers_step_description2_margin}>
        {data?.phone}
      </p>

      <div className={s.vouchers_step_title3 + ' ' + s.vouchers_step_title3_margin}>Message</div>

      <p className={s.vouchers_step_description2 + ' ' + s.vouchers_step_description2_margin}>
        {messageVaucher}
      </p>

      <div className={s.vouchers_step_title2}>Date and time of sending</div>

      <p className={s.vouchers_step_description2 + ' ' + s.vouchers_step_description2_margin}>
        {formatDeliveryDateTime()}
      </p>

      <div className={s.vouchers_step_total}>Total</div>

      <div className={s.vouchers_step_price}>
        <RiyalIcon className={s.riyal_icon} />
        {voucherData.value}
      </div>

      <Button
        darkGreen
        wide
        onClick={handlePay}
        className={s.vouchers_step_button}
        loading={isLoading}
      >
        Buy now
      </Button>
      {errorMessage ? <span className={s.error_message}>{errorMessage}</span> : <></>}
    </div>
  );
};

export default ResultStep;
